import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { SUBMENU } from "../utils/constants";
import TeamDashboard from "../pages/TeamDashboard";   // (vezi pasul 3)
import { getSession } from "../utils/helpers";

export default function EchipaEntry() {
  const navigate = useNavigate();
  const location = useLocation();

  const defaultTab = SUBMENU.echipa[0].slug; // "calendar"

  useEffect(() => {
    const q = new URLSearchParams(location.search);
    const orgQ = q.get("org");
    const echipaQ = q.get("echipa");
    const tabQ = q.get("tab");
    const viewQ = q.get("view");           // 👈 NEW

    const validTabs = SUBMENU.echipa.map((i) => i.slug);

    const session = getSession();
    const orgSess = session?.organization?.organization_slug || "";
    const echSess = session?.team?.slug || "";

    const needOrg = !orgQ;
    const needEch = !echipaQ;
    // const needTab    = !tabQ || !validTabs.includes(tabQ);

    /* tab e necesar DOAR dacă nu avem view sau (avem tab dar e invalid) */
    const tabMissingAndNoView = !tabQ && !viewQ;
    const invalidTab = tabQ && !validTabs.includes(tabQ);
    const needTab = tabMissingAndNoView || invalidTab;   // 👈 modificat


    if (needOrg || needEch || needTab) {
      const finalOrg = needOrg ? orgSess : orgQ;
      const finalEch = needEch ? echSess : echipaQ;
      const finalTab = needTab ? defaultTab : tabQ;
      const qsParts = [
        `org=${finalOrg}`,
        `echipa=${finalEch}`,
        viewQ ? `view=${viewQ}` : `tab=${finalTab}`
      ];

      navigate(`/echipa?${qsParts.join("&")}`, { replace: true });
      // navigate(
      //   `/echipa?org=${finalOrg}&echipa=${finalEch}&tab=${finalTab}`,
      //   { replace: true }
      // );
    }
  }, [location.search, navigate]);

  return <TeamDashboard />;
}
